// extracted by mini-css-extract-plugin
export var description = "EmailConfirmationForm-module--description--32dtn";
export var errorWrapper = "EmailConfirmationForm-module--errorWrapper--DtUrD";
export var headline = "EmailConfirmationForm-module--headline--1RmiG";
export var inputWrapper = "EmailConfirmationForm-module--inputWrapper--v4m9S";
export var loadingWrapper = "EmailConfirmationForm-module--loadingWrapper--GGYvG";
export var sendEmailBtn = "EmailConfirmationForm-module--sendEmailBtn--HEMA-";
export var submitBtn = "EmailConfirmationForm-module--submitBtn--9Xbcb";